<template>
  <div>
    <div class="row">
      <div class="col-sm-3">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">{{ $t('COMMON.NEW_MODEL') }}</h5>
            <b-button v-b-modal.addModal variant="primary" > + {{ $t('COMMON.ADD_MODEL') }}</b-button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-3" v-for="model in model_status" :key="model.id">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">{{model.name}}</h5>
            <b-row>
              <b-col>
                <small class="card-subtitle"><i>{{model.default_name}}</i></small>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <template v-if="model.status === 'UNDEPLOYED'" >
                <b-button v-on:click = "deploy(model.id)" variant="success"> DEPLOY </b-button>
                </template>
                <template v-if="model.status === 'DEPLOYED'" >
                  <b-button  v-on:click = "undeploy(model.id)" variant="danger"> UNDEPLOY </b-button>
                </template>
                <template v-if="model.status === 'DEPLOYING'" >
                  <b-button disabled  variant="success"> DEPLOYING </b-button>
                </template>
                <template v-if="model.status === 'UNDEPLOYING'" >
                  <b-button disabled variant="danger"> UNDEPLOYING </b-button>
                </template>
                <b-button variant="danger" @click="confirmDeleteModel(model.id)" v-b-tooltip.hover :title="$t('COMMON.DELETE_PERMANENTLY')"><i class="fa fa-trash"></i></b-button>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
    <b-modal
        id="addModal"
        ref="modal"
        title="Add New Model"
        @show="resetModal"
        @hidden="resetModal"
        @ok="handleOk"
      >
      <form ref="form" @submit.stop.prevent="handleOk">
        <b-row>
          <b-col cols="4"><label class="mt-2">{{ $t('FORMS.MODEL_NAME')}}</label></b-col>
          <b-col cols="8">
            <b-form-group>
              <input type="text"
                    class="form-control"
                    :class="{'is-invalid': $v.model_name.$error, 'is-valid': !$v.model_name.$invalid}"
                    @input="$v.model_name.$touch()"
                    :placeholder="$t('COMMON.NAME')"
                    v-model="model_name">
                <b-form-invalid-feedback v-if="!$v.model_name.isUnique">{{ $t('COMMON.MODEL_EXIST') }}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.model_name.required">{{ $t('FORMS.MODEL_NAME_ERR') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4"><label class="mt-2">{{ $t('FORMS.SELECT_MODEL') }}</label></b-col>
          <b-col cols="8">
            <b-form-group :invalid-feedback="$t('FORMS.SELECT_MODEL')">
              <b-form-select v-model="model_id"
                :options="setOptions"
                class="form-control"
                :class="{'is-invalid': $v.model_id.$error, 'is-valid': !$v.model_id.$invalid}">
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
      </form>
    </b-modal>
    <b-modal hide-header-close centered :title="$t('COMMON.DELETE_CONFIRM')" ref="delete_model" @hidden="cancelDelete" :ok-title="$t('COMMON.DELETE')" :cancel-title="$t('COMMON.CANCEL')" @ok="deleteModel" ok-variant="secondary" cancel-variant="light">
      <div class="delete-warning">
        <p>The Model will be deleted from the system</p>
        <p>Are you sure you want to delete?</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import router from '../../router'
import { required } from 'vuelidate/lib/validators'
import _ from 'lodash'

export default {
  data () {
    return {
      model_name: '',
      polling: null,
      model_status: [],
      model_id: null,
      undeployed_models: null,
      tempOptions: [],
      options: [],
      selected_model: null
    }
  },
  computed: {
    ...mapGetters(['idToken', 'isSuperAdmin']),
    setOptions () {
      var arrayStatus = []
      this.model_status.forEach(element => {
        arrayStatus.push(element.model_id)
      })
      this.tempOptions = this.tempOptions.filter(element => {
        return !arrayStatus.includes(element.value)
      })
      this.options = [{ text: this.$t('FORMS.SELECT_MODEL'), value: null, disabled: true }]
      this.options = this.options.concat(this.tempOptions.map(modelType => { return { text: modelType.text, value: modelType.value } }))
      return this.options
    }
  },
  validations: {
    model_name: {
      required,
      isUnique (value, vm) {
        if (value === '') return true
        return new Promise((resolve, reject) => {
          resolve(!_.some(this.model_status, {'name': value.toUpperCase()}))
        })
      }
    },
    model_id: {
      required
    }
  },
  created () {
    this.polling = setInterval(() => {
      this.fetchModelStatus()
    }, 60000)
  },
  beforeDestroy () {
    clearInterval(this.polling)
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.isSuperAdmin) {
        Vue.axios.get('admin/manage_models', { headers: { Authorization: `Bearer ${vm.idToken}` } })
          .then(res => {
            vm.model_status = res.data.status
            vm.undeployed_models = res.data.undeployed_models
            for (var key in vm.undeployed_models) {
              if (vm.undeployed_models.hasOwnProperty(key)) {
                let option = {}
                option.text = vm.undeployed_models[key].name
                option.value = key
                vm.tempOptions.push(option)
              }
            }
            next()
          })
          .catch(error => {
            if (error.status === 401) {
              Vue.toasted.show(vm.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
              console.log(this.$t('COMMON.MSG_EXPIRED'))
            } else {
              Vue.toasted.show(vm.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            }
          })
      } else {
        router.replace('/Not-Found-404')
      }
    })
  },
  methods: {
    resetModal () {
      this.model_name = ''
      this.model_id = null
    },
    handleOk (bvModalEvt) {
      if (this.model_id && this.model_name) {
        this.handleSubmit()
      } else {
        this.$v.model_name.$touch()
        this.$v.model_id.$touch()
        bvModalEvt.preventDefault()
      }
    },
    handleSubmit () {
      let newModel = {}
      newModel.model_id = this.model_id
      newModel.default_name = this.undeployed_models[this.model_id].name
      newModel.name = this.model_name.toUpperCase()
      newModel.status = this.undeployed_models[this.model_id].status
      Vue.axios.post('admin/manage_models/add_model', {newModel}, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          if (res.data.msg === 'success') {
            Vue.toasted.show(res.data.msg)
            this.model_status.push(res.data.model)
          } else {
            Vue.toasted.show(res.data.error, { type: 'error' })
          }
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
      this.$nextTick(() => {
        this.$refs.modal.hide()
      })
    },
    deploy: function (id) {
      Vue.axios.post('admin/manage_models/' + id + '/deploy', {}, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          if (res.data.state === 'deploy') {
            Vue.toasted.show(res.data.msg)
            for (let i = 0; i < this.model_status.length; i = i + 1) {
              if (this.model_status[i].id === id) {
                this.model_status[i].status = 'DEPLOYING'
              }
            }
          } else {
            Vue.toasted.show(res.data.msg, { icon: 'chain-broken', type: 'error' })
          }
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    undeploy: function (id) {
      Vue.axios.post('admin/manage_models/' + id + '/undeploy', {}, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          if (res.data.state === 'undeploy') {
            Vue.toasted.show(res.data.msg)
            for (let i = 0; i < this.model_status.length; i = i + 1) {
              if (this.model_status[i].id === id) {
                this.model_status[i].status = 'UNDEPLOYING'
              }
            }
          } else {
            Vue.toasted.show(res.data.msg, { icon: 'chain-broken', type: 'error' })
          }
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    fetchModelStatus: function () {
      if (this.isSuperAdmin) {
        Vue.axios.get('admin/manage_models', { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(res => {
            this.model_status = res.data.status
          })
          .catch(error => {
            if (error.status === 401) {
              Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
              console.log(this.$t('COMMON.MSG_EXPIRED'))
            } else {
              Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            }
          })
      } else {
        router.replace('/Not-Found-404')
      }
    },
    confirmDeleteModel (id) {
      this.selected_model = id
      this.$refs.delete_model.show()
    },
    cancelDelete () {
      this.selected_model = null
    },
    deleteModel () {
      if (this.selected_model) {
        Vue.axios.post('admin/manage_models/delete_model?id=' + this.selected_model, {}, { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(res => {
            if (res.data.status === 'success') {
              this.model_status.forEach(element => {
                if (element.id === this.selected_model) {
                  this.tempOptions.push({ 'text': element.default_name, 'value': element.model_id })
                }
              })
              this.model_status = this.model_status.filter(function (model) { return model.id !== parseInt(res.data.id, 10) })
              Vue.toasted.show(res.data.status)
            } else {
              Vue.toasted.show(res.data.status, { icon: 'chain-broken', type: 'error' })
            }
          })
          .catch(error => {
            if (error.status === 401) {
              Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
              console.log(this.$t('COMMON.MSG_EXPIRED'))
            } else {
              Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            }
          })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/superAdmin/models.vue